import ResourceModel from "models/convention-api/ResourceModel"
import ConventionMeetingAvailability from "models/convention-api/v1/ConventionMeetingAvailability"
import moment from "moment-timezone"

export default class ConventionMeetingRegistration extends ResourceModel {
  protected static basePath =
    "/v1/convention_providers/:provider_id/convention_meeting_registrations"

  protected static rels = {
    conventionMeetingAvailability: () => ({
      type: ConventionMeetingAvailability,
      from: "convention_meeting_availability_id",
      filterOn: "id",
    }),
  }

  convention_meeting_availability_id!: string
  convention_meeting_availability_provider_id!: string
  end_at!: moment.Moment
  start_at!: moment.Moment

  conventionMeetingAvailability?: ConventionMeetingAvailability
}
